import {handleActions} from 'redux-actions';
import * as type from './actionTypes';
const initState = {

}
const actions = {}

actions[type.GET_ORDER_LIST] = (state, action) => {
    return{
        ...state,
        orderList:action.payload,
    }
}
actions[type.GET_ORDER_DETAIL] = (state, action) => {
    return{
        ...state,
        orderDetail:action.payload,
    }
}

export const orderInfoReducer = handleActions(actions, initState)
